<template>
    <div>
      <b-overlay :show="dataOverlay" spinner-variant="success" no-wrap></b-overlay>
  
      <div 
        v-if="!isHideHeader"
        class="d-flex justify-content-between align-items-center mb-4"
      >
        <h5 class="m-0">Детали проверки {{ `${items.company.name} (ИНН: ${items.company.inn})` }}</h5>
        <b-badge :variant="items.is_liquidated ? 'danger' : 'success'" class="px-3 py-2 text-uppercase">
          {{ items.is_liquidated ? 'Ликвидирована' : 'Активна' }}
        </b-badge>
      </div>
  
      <b-card>
        <h6 class="mb-2 text-primary">Информация из DaData (проверка выполнялась: {{ items.created_at }})</h6>
        <b-row>
          <b-col cols="12" md="6">
            <p><strong>Полное наименование:</strong><br> {{ dadataName('full_with_opf') }}</p>
            <p><strong>Краткое наименование:</strong><br> {{ dadataName('short_with_opf') }}</p>
            <p><strong>ОПФ:</strong><br> {{ dadataOpf('full') }} ({{ dadataOpf('short') }})</p>
          </b-col>
  
          <b-col cols="12" md="6">
            <p><strong>ИНН / КПП:</strong><br> {{ dadataField('inn') }} / {{ dadataField('kpp') }}</p>
            <p><strong>ОГРН:</strong><br> {{ dadataField('ogrn') }} от {{ formatDate(dadataField('ogrn_date')) }}</p>
            <p><strong>ОКПО / ОКАТО / ОКТМО:</strong><br>
              {{ dadataField('okpo') }} / {{ dadataField('okato') }} / {{ dadataField('oktmo') }}
            </p>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="12" md="6">
            <p><strong>Основной ОКВЭД:</strong><br> {{ dadataField('okved') }}</p>
            <p><strong>Тип организации:</strong><br> {{ dadataField('type') === 'LEGAL' ? 'Юр. лицо' : 'ИП' }}</p>
          </b-col>
  
          <b-col cols="12" md="6">
            <p><strong>Филиалы:</strong><br>
              {{ dadataField('branch_type') === 'MAIN' ? 'Головная организация' : 'Филиал' }},
              {{ dadataField('branch_count') || 0 }} филиалов
            </p>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="12">
            <p><strong>Адрес (короткий):</strong><br> {{ dadataAddress('value') }}</p>
            <p><strong>Адрес (полный):</strong><br> {{ dadataAddress('unrestricted_value') }}</p>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="12" md="6">
            <p><strong>Руководитель:</strong><br>
              <template v-if="dadata.management">
                {{ dadata.management.name }}<br>
                Назначен: {{ formatDate(dadata.management.start_date) }}
              </template>
              <template v-else>—</template>
            </p>
          </b-col>
  
          <b-col cols="12" md="6">
            <p><strong>Дата регистрации:</strong><br> {{ formatDate(dadataState('registration_date')) }}</p>
            <p><strong>Статус:</strong><br> {{ dadataState('status') }}</p>
            <p v-if="dadata.state && dadata.state.liquidation_date">
              <strong>Дата ликвидации:</strong><br> {{ formatDate(dadataState('liquidation_date')) }}
            </p>
          </b-col>
        </b-row>
      </b-card>
    </div>
</template>

<script>
  import { API_COMPANY_DADATA_CHECK } from '@/constants'
  
  const NO_DATA = 'Данные отсутствуют'
  
  export default {
    props: {
        isHideHeader: { type: Boolean, default: false },
        itemId: { type: Number, required: false },
        companyId: { type: Number, required: false },
    },
    data() {
      return {
        api: API_COMPANY_DADATA_CHECK,
        items: '',
        dataOverlay: true,
      }
    },
    computed: {
      dadata() {
        return this.items && this.items.dadata_data ? this.items.dadata_data : {}
      }
    },
    mounted() {
        if (this.itemId) {
            this.getDadataCheckDetails('id', this.itemId)
        }
        if (this.companyId) {
            this.getDadataCheckDetails('company_id', this.companyId)
        }
    },
    methods: {
      getDadataCheckDetails(type, id) {
        let request = `${this.api}/${id}`;

        if (type === 'company_id') {
            request = `${this.api}/by-company/${id}`;
        }

        api.call('get', request).then(({ data }) => {
          this.items = data
          this.dataOverlay = false
        })
      },
      formatDate(timestamp) {
        if (!timestamp) return NO_DATA
        const date = new Date(Number(timestamp))
        return date.toLocaleDateString('ru-RU')
      },
      dadataField(key) {
        return this.dadata[key] ? this.dadata[key] : NO_DATA
      },
      dadataOpf(key) {
        return this.dadata.opf && this.dadata.opf[key] ? this.dadata.opf[key] : NO_DATA
      },
      dadataName(key) {
        return this.dadata.name && this.dadata.name[key] ? this.dadata.name[key] : NO_DATA
      },
      dadataAddress(key) {
        return this.dadata.address && this.dadata.address[key] ? this.dadata.address[key] : NO_DATA
      },
      dadataState(key) {
        return this.dadata.state && this.dadata.state[key] ? this.dadata.state[key] : NO_DATA
      }
    }
  }
</script>
  
<style scoped>
    .table-title-details {
        font-weight: bold;
        width: 200px;
        white-space: nowrap;
    }
</style>
